// extracted by mini-css-extract-plugin
export var root = "tyzi";
export var rootInput = "A2ZW";
export var rootLabel = "zjcB";
export var rootLabelError = "Bl3k";